import React, { useState, useEffect } from 'react';
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from 'reactstrap';

const VWOffCanvas = ({ header, children, isOpen, handleClose, modalSize, className }) => {
    const [sizeClassName, setSizeClassName] = useState('');


    useEffect(() => {
        const baseClassName = 'modal';
        switch (modalSize) {
            case 'small':
                setSizeClassName(` ${baseClassName}-sm`);
                break;
            case 'large':
                setSizeClassName(` ${baseClassName}-lg`);
                break;
            case 'extra-large':
                setSizeClassName(` ${baseClassName}-xl`);
                break;
            case 'xxl':
                setSizeClassName(` ${baseClassName}-xxl`);
                break;
            default:
                setSizeClassName(` ${baseClassName}-custom-width`);
        }
    }, [modalSize]);

    const renderClassName = (modalSize, className) => {
        if (className) {
            return `${sizeClassName} ${className}`;
        }
        return `${sizeClassName}`;
    };

    return (
        <Offcanvas isOpen={isOpen} direction="end" className={renderClassName(modalSize, className)} autoFocus={false}>
            <OffcanvasHeader toggle={handleClose}>{header}</OffcanvasHeader>
            <OffcanvasBody>{children}</OffcanvasBody>
        </Offcanvas>
    );
}
export default VWOffCanvas;
